import { fetchQuery, graphql } from "relay-runtime"
import {
  fetchChatTemplatesQuery,
  fetchChatTemplatesQuery$data,
} from "@/modules/chats/services/__generated__/fetchChatTemplatesQuery.graphql"
import { ExtractNode } from "@/modules/patients/types/ExtractNode"
import { RelayEnvironment } from "@/relay-environment"
import { ChatTemplateType, Country, Language } from "@/types/__generated__/union-types"

export type ChatTemplatesData = ExtractNode<fetchChatTemplatesQuery$data["activeChatTemplates"]>
export type ChatTemplatesDataLanguages = ChatTemplatesData["languages"][0]

export interface ChatTemplateStoreData extends ChatTemplatesDataLanguages {
  name: string
  services: ReadonlyArray<ChatTemplateType>
}

export function fetchChatTemplates(patientCountry: Country): Promise<Map<Language, ChatTemplateStoreData[]>> {
  return new Promise((resolve) => {
    fetchQuery<fetchChatTemplatesQuery>(
      RelayEnvironment,
      graphql`
        query fetchChatTemplatesQuery($country: Country!) {
          activeChatTemplates(country: $country) {
            edges {
              cursor
              node {
                chatTemplateTypes
                name
                languages {
                  content
                  language
                  synonym
                  title
                }
              }
            }
          }
        }
      `,
      { country: patientCountry },
    ).subscribe({
      next: (data) => {
        const chatTemplates = data.activeChatTemplates?.edges ?? []
        const chatTemplatesData: Map<Language, ChatTemplateStoreData[]> = new Map()

        for (const { node } of chatTemplates) {
          for (const language of node.languages) {
            const chatTemplatesStore = chatTemplatesData.get(language.language) ?? []
            chatTemplatesStore.push({
              language: language.language,
              content: language.content,
              synonym: language.synonym,
              title: language.title,
              name: node.name,
              services: node.chatTemplateTypes,
            })
            chatTemplatesData.set(language.language, chatTemplatesStore)
          }
        }

        resolve(chatTemplatesData)
      },
    })
  })
}
